import React, { useEffect, useState } from 'react';
import { Text, Box, Flex, Button } from 'rebass';
import { IoIosArrowBack } from 'react-icons/io';
import { keyframes } from '@emotion/react';
import { ReactComponent as BabysFYLabel } from 'babys-first-year/assets/babyyearbookslabel.svg';
import { checkIsIpadUser, useCheckIsIosUser, useIsSafariUser } from 'story-media/hooks';
import UAParser from 'ua-parser-js';
import { useMyChildJournals } from 'account-dashboard/hooks';

const slideDown = keyframes`
  0% { transform: translateY(-100%); }
  100% { transform: translateY(0); }
`;

const rotate = keyframes`
  0% { transform: translateX(100%); }
  100% { transform: translateX(0);  }
`;

const Wrapper = ({ isSlideDownTransition = false, childBg = "#FAFAFA", renderheader, onHideSkip, hideSkip = true, children, isDisabled = false, noOfTransitions = 0, nextButtonText = "Continue", onSubmit, showFooter = true, isSubmitting, onBack, buttonSx }) => {
    const [animationStyle, setAnimationStyle] = useState({});
    const iOSUser = useCheckIsIosUser()
    const isIpadUser = checkIsIpadUser();
    const isSafariUser = useIsSafariUser();

    const { journals } = useMyChildJournals();
    const hasInitializedJournal = journals.some((journal) => journal?.state === "initialized");

    const parser = new UAParser();
    const browserName = parser.getResult().browser.name;

    const animateElement = () => {
        setAnimationStyle((prevStyle) => ({
            ...prevStyle,
            opacity: 0,
            animation: 'unset',
        }));

        setTimeout(() => {
            setAnimationStyle((prevStyle) => ({
                ...prevStyle,
                opacity: 1,
                animation: `${isSlideDownTransition ? slideDown : rotate} 1s ease`,
            }));
        }, 500);
    };

    useEffect(() => {
        animateElement()
    }, [noOfTransitions])

    return (
        <Flex bg="white" flexDirection='column' width="100vw" height='100vh' sx={{ position: 'fixed', bottom: 0, top: 0 }}>
            {!hasInitializedJournal && <Flex p={2} justifyContent={'space-between'} alignItems="center" >
                <Flex width={['160px', '300px', "100%"]}>
                    <BabysFYLabel />
                </Flex>
                {onHideSkip && <Text onClick={onHideSkip} sx={{ cursor: 'pointer' }} minWidth="max-content" fontFamily="Bitter" color="codGrey" fontSize="16px" fontWeight={500} letterSpacing="0.352px" lineHeight="120%">
                    Skip for Later <b>{'>'}</b>
                </Text>}
            </Flex>}
            <Flex sx={animationStyle} flexDirection="column" width="100%" bg={childBg}>
                <Box
                    // height={
                    //     showFooter
                    //         ? isIpadUser
                    //             ? "calc(100vh - 220px)"
                    //             : iOSUser && !(browserName.toLowerCase().includes('instagram') ||
                    //                 browserName.toLowerCase().includes('facebook'))
                    //                 ? [
                    //                     `calc(100vh - ${isSafariUser ? '230px' : '250px'})`,
                    //                     `calc(100vh - ${isSafariUser ? '180px' : '230px'})`,
                    //                     `calc(100vh - ${isSafariUser ? '150px' : '150px'})`
                    //                 ]
                    //                 : "calc(100vh - 150px)"
                    //         : "calc(100vh - 72px)"
                    // }
                    sx={{
                        height: '100vh',
                        overflow: 'scroll',
                        paddingBottom: '200px'
                    }}>
                    {renderheader ? renderheader() : null}
                    {children}
                </Box>
            </Flex>
            {showFooter && <Flex bg="#fff" p={2} mb={1} sx={{ position: 'fixed', bottom: 0, width: '100%' }}>
                {onBack && <Flex
                    height={40}
                    justifyContent="space-around"
                    alignItems="center"
                    bg="#fff"
                    sx={{ borderRadius: 'medium', cursor: !onBack ? 'not-allowed' : 'pointer' }}
                    onClick={onBack}
                >
                    <Text as={IoIosArrowBack} color="mineShaft" size={24} />
                    <Text minWidth={'max-content'} color="mineShaft" fontFamily="Poppins" lineHeight={'150%'} ml={1} fontWeight={400} fontSize="15px">
                        Back
                    </Text>
                </Flex>}

                {onSubmit && <Button
                    height={40}
                    py={1}
                    px={[2, 5]}
                    bg={isSubmitting ? "grey" : "brand"}
                    onClick={onSubmit}
                    disabled={isSubmitting || isDisabled}
                    sx={{ borderRadius: '23px', opacity: isDisabled ? 0.5 : 1, display: 'flex', justifyContent: 'center', alignItems: 'center', ml: 'auto', ...buttonSx }}
                >
                    <Text className={isSubmitting && "loading"} color="white" fontFamily="Poppins" fontSize="16px" fontWeight={500} lineHeight={'20px'} letterSpacing="-0.096px">
                        {nextButtonText}
                    </Text>
                </Button>}
            </Flex>}
        </Flex>
    );
};

export default Wrapper;
